module.exports = __webpack_public_path__ + "img/jigsawPuzzle_2.49f6471e.png";